export default {
	lang: 'ko',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav":"보르모르 AI",
		"nav2":"계정 보안",
		"nav3":"내 클라우드 디스크",
		"nav4":"로그아웃",
		"nav5":"로그인",
		"nav6":"클라우드 공간",
		"nav7":"ChatGPT 대형 모델",
		"nav8":"스마트 음성 녹음기 클라우드 공간 시스템",
		"nav_phone_number_code":'휴대폰 번호',
		"nav_update":'교체',
		"nav_bind":'바인딩',
		"nav_phone_code_tips":'본인 인증을 위해 휴대폰 인증번호로 본인 확인을 완료해 주세요',
		"nav_phone_number":'휴대폰 번호',
		"nav_phone_number_verify":'휴대폰 번호 인증 전환',
		"nav_phone_email_verify":'이메일 인증 전환',
		"nav_set_phone_number":'새 휴대폰 번호 설정',
		"nav_verify_login":'로그인 검증',
		"nav_phone_email":'이메일/휴대폰 번호',
		"nav_phone_login":'휴대폰 인증 로그인',
		"nav_email_login":'이메일 인증 로그인',
		"nav_email_fail":'이메일 형식이 잘못되었습니다. 다시 입력해 주세요.',
		"nav_pw_fail":'비밀번호 형식이 잘못되었습니다. 다시 입력해 주세요.',
		"nav_code_fail":'인증코드 오류',
		"nav_phone_fail":'휴대폰 번호 형식이 잘못되었습니다. 다시 입력해 주세요.',
		"nav_input_fail":'이메일을 입력해 주세요.',
		"nav_input_phone":'휴대폰 번호를 입력해 주세요',
		"nav_phone_verify_back":'휴대폰 인증 찾기',
		"nav_email_verify_back":'이메일 인증으로 찾기'
	},
	login: {
		"login1":"비밀번호 로그인",
		"login2":"SMS 로그인",
		"loginTab3":"이메일 로그인",
		"login3":"우편",
		"login4":"로그인 비밀번호",
		"login5":"전화 번호",
		"login6":"선택해주세요",
		"login7":"모바일 인증 코드",
		"login8":"로그인",
		"login9":"비밀번호를 잊어버리다",
		"login10":"등록하다",
		"login11":"로그인하면 동의합니다",
		"login12":"서비스 계약",
		"login13":"개인정보 보호정책",
		"login14":"얻다",
		"login15":"중국",
		"login16":"계좌번호를 입력해주세요",
		"login17":"비밀번호를 입력하세요",
		"login18":"로그인이 성공했습니다!",
		"login19":"인증번호를 입력하세요!",
		"login20":"성공적으로 전송되었습니다!",
		"login21":"그리고",
		"login22":"음성 녹음기 클라우드 디스크",
		"login23":"내 글",
		"login24":"내 대화",
		"login25":"계정 보안",
		"login26":"로그아웃",
		"login27":"이메일을 통해 비밀번호 찾기",
		"login28":"우편",
		"login29":"이메일 인증 코드",
		"login30":"로그인 비밀번호 설정 (6~16자)",
		"login31":"로그인 비밀번호를 다시 입력하세요",
		"login32":"제출하다",
		"login33":"로그인으로 돌아가기",
		"login34":"수정이 성공했습니다!",
	},
	register: {
		"register1":"전화 번호",
		"register2":"전화번호를 입력해주세요",
		"register3":"선택해주세요",
		"register4":"모바일 인증 코드",
		"register5":"비밀번호 설정",
		"register6":"인증번호를 입력해주세요",
		"register7":"6~16자",
		"register8":"비밀번호 확인",
		"register9":"우편",
		"register10":"이메일 주소를 입력해주세요",
		"register11":"이메일 인증 코드",
		"register12":"인증번호를 입력해주세요",
		"register13":"나는 읽었고 동의합니다",
		"register14":"동의하시는 항목을 읽고 체크해 주세요.",
		"register15":"전화번호 형식이 올바르지 않습니다/전화번호가 등록되었습니다",
		"register16":"모바일 인증 코드 오류",
		"register17":"이메일 주소를 입력해 주세요 / 이메일 주소 형식이 올바르지 않습니다",
		"register18":"이메일 형식 오류",
		"register19":"이메일 인증 코드 오류",
		"register20":"비밀번호는 6~16자로 설정해주세요.",
		"register21":"비밀번호 형식 오류",
		"register22":"두 번 입력하신 비밀번호가 일치하지 않습니다. 다시 입력해 주세요.",
		"register23":"비밀번호를 입력하세요",
		"register24":"등록이 성공했습니다!",
		"register25":"인증 코드 오류",
	},
	recorder:{
"recorder1":"음성 녹음기 클라우드 디스크",
    "recorder2":"클라우드 공간 용량",
    "recorder3":"문서",
    "recorder331":"휴지통",
    "recorder332":"모두 지우기",
    "recorder4":"이름",
    "recorder5":"오디오 길이",
    "recorder6":"파일 크기",
    "recorder7":"창조 시간",
    "recorder8":"작동하다",
    "recorder9":"클라우드 공간 설명",
    "recorder10":"문서",
    "recorder11":"OCR 파일",
   "recorder12":'1. 클라우드 공간 용도',
   "recorder13":'스마트 오피스북, 녹음펜에 녹음, 필기 노트를 저장한 후 클라우드를 전송할 수 있으며, 스마트 기기가 곁에 없더라도 클라우드 공간에 들어가 필기 파일을 볼 수 있습니다.',
   "recorder14":'2. 클라우드 공간은 어떻게 업로드합니까?',
   "recorder15":'녹음펜: 장치 [내 파일] 진입 → 대량 작업 클릭 → 업로드를 클릭하면 파일을 클라우드 업로드 대기열에 추가하여 클라우드 공간에 업로드할 수 있습니다.',
   "recorder16":'스마트 오피스:',
   "recorder17":'방식1: 필기목록에서 길게 누르고 업로드해야 할 필기를 대량으로 선택→"동기화"를 클릭하여 업로드를 완성한다.',
   "recorder171":'방식 2: 단일 노트 상세 정보 페이지 열기 → [더 많은-동기화] 를 클릭하면 이 노트를 클라우드 공간에 업로드할 수 있습니다.',
    "recorder18":"전사되지 않음",
    "recorder19":"요약 보기",
    "recorder20":"스피커",
    "recorder21":"스피커 이름 편집",
    "recorder22":"확신하는",
    "recorder23":"다운로드",
    "recorder24":"콘텐츠 다운로드:",
    "recorder25":"다운로드 설정:",
    "recorder26":"스피커 표시",
    "recorder27":"취소",
    "recorder28":"링크 공유",
    "recorder29":"링크를 받은 사람은 누구나 접근할 수 있습니다. 읽기 전용이며, 링크는 7일 동안 유효합니다.",
    "recorder30":"링크 복사",
    "recorder31":"스캔하여 빠르게 확인하세요",
    "recorder32":"스마트한 조직",
    "recorder33":"스피커를 구별하다",
    "recorder34":"화자 역할에 따라 필사된 텍스트를 지능적으로 구별합니다.",
    "recorder35":"지능형 음성 언어 정규화",
    "recorder36":"모달 입자, 반복 단어 및 일시 정지 단어를 자동으로 필터링합니다.",
    "recorder37":"비음성 필터링",
    "recorder38":"재생 중 음성이나 소음 없이 오디오를 자동으로 건너뜁니다.",
    "recorder39":"선택해주세요",
    "recorder40":"문서",
    "recorder41":"오디오",
    "recorder42":"문서 + 오디오",
    "recorder43":"힌트",
    "recorder44":"이 작업을 수행하면 파일이 삭제됩니다. 계속하시겠습니까?",
    "recorder441":"이 작업을 수행하면 모든 파일이 삭제됩니다. 계속하시겠습니까?",
    "recorder45":"확신하는",
    "recorder46":"취소",
    "recorder47":"성공적으로 삭제되었습니다!",
    "recorder48":"삭제되지 않음",
    "recorder49":"아직 태그가 없습니다",
    "recorder50":"절약...",
    "recorder51":"휴지통",
	},
	personal: {
		"personal1":"계정 설정",
		"personal2":"개인 정보",
		"personal3":"화신",
		"personal4":"파일 업로드",
		"personal5":"JPG, JPEG, GIF, PNG 스타일 지원, 2M 이내의 사진 지원",
		"personal6":"별명",
		"personal7":"별명을 입력해주세요",
		"personal8":"성별",
		"personal9":"신사",
		"personal10":"놓치다",
		"personal11":"기밀 유지",
		"personal12":"생일",
		"personal13":"생일을 선택해주세요",
		"personal14":"직업",
		"personal15":"직업을 선택해주세요",
		"personal16":"직업을 입력해 주세요 (선택사항)",
		"personal17":"국가",
		"personal18":"귀하의 국가를 선택해 주세요",
		"personal19":"저장",
		"personal20":"개인 정보",
		"personal21":"계정 보안",
		"personal22":"2M 이내의 이미지만 지원합니다.",
		"personal23":"업로드가 성공했습니다!",
		"personal24":"수정이 성공했습니다!",
		"personal25":"계정 보안",
		"personal26":"로그인 비밀번호",
		"personal27":"개정하다",
		"personal28":"이메일",
		"personal29":"바꾸다",
		"personal30":"계정 취소",
		"personal32":"정말로 계정을 취소하시겠습니까?",
		"personal33":"로그아웃 후에는 계정 내의 모든 콘텐츠가 삭제되므로 주의해서 진행해주시기 바랍니다.",
		"personal34":"취소",
		"personal35":"확신하는",
		"personal36":"입증",
		"personal37":"본인 확인이 필요하신 경우, 이메일 인증코드를 통해 본인 확인을 완료해 주시기 바랍니다.",
		"personal38":"우편",
		"personal39":"인증 코드",
		"personal40":"인증번호를 입력해주세요",
		"personal41":"다음 단계",
		"personal42":"새 사서함 설정",
		"personal43":"우편",
		"personal44":"새로운 이메일 주소를 입력하세요",
		"personal45":"인증 코드",
		"personal46":"인증번호를 입력해주세요",
		"personal47":"확신하는",
		"personal48":"새로운 로그인 비밀번호를 설정하세요",
		"personal49":"새로운 로그인 비밀번호",
		"personal50":"새로운 비밀번호를 입력하세요",
		"personal51":"새 비밀번호 확인",
		"personal52":"새로운 비밀번호를 다시 입력하세요",
		"personal53":"확신하는",
		"personal54":"얻다",
		"personal55":"이메일 형식 오류",
		"personal56":"교체가 성공했습니다!",
		"personal57":"비밀번호는 6~16자로 설정해주세요.",
		"personal58":"두 번 입력하신 비밀번호가 일치하지 않습니다.",
		"personal59":"수정이 성공했습니다!",
		"personal60":"로그아웃이 성공했습니다!",
		
		"share_url": "링크 공유",
		"share_url_7_day": "공유 링크는 7일 동안 유효합니다. 만료되기 전에는 링크를 받은 모든 사람이 액세스할 수 있습니다.",
		"share_audio": "오디오 녹음",
		"share_trans_text": "녹음",
		"share_summny_text": "요약",
		"share_map": "마인드맵",
		"share_url_pw": "액세스 암호화",
		"share_random_pw": "비밀번호는 무작위로 생성됨",
		"share_url_copy": "링크 복사",
		"share_url_copy_success": "링크 복사 성공",
		"share_link_pw": "액세스 비밀번호",
		"share_copy_success": "전사본이 클립보드에 복사되었습니다!",
		"share_copy_success2": "요약 내용이 클립보드에 복사됨!",
		"share_speaker": "발언자",
		"share_no_update_speaker": "발언자를 편집할 수 없습니다. 비어 있음",
		"share_no_trans":"텍스트 변환 없음",
		"share_no_summny":"요약 없음",
		"share_no_map":"지도 콘텐츠 없음",
		"share_trans_text_1": "텍스트 변환",
		"share_summny_text_1": "요약",
		"share_map_1": "지도",
		"share_save": "저장 성공",
		"share_no_map":"지도 이미지가 생성되지 않았습니다",
		"share_update_text": "텍스트 변환 내용 수정",
		"share_update_text2": "요약 텍스트 편집",
		"showLoading": "로딩 중...",
		"handwriting": "필기 콘텐츠",
		"handwritingText": "필기",
		"share_1": "이 페이지의 필기 내용을 인식할 수 없습니다.",
		"share_2": "필기 인식 편집",
		"share_3": "필기 인식",
		"share_4":"파일을 내보내는 중입니다. 이 페이지를 떠나지 마십시오.",
		"folder_text":"폴더",
		"folder_text_update_name":"이름 변경",
		"folder_text_del":"삭제",
		"folder_text_all":"모두",
		"folder_text_type":"파일 형식",
		"folder_text_audio":"오디오 메모",
		"folder_text_writing":"필기 메모",
		"folder_text_file_type":"파일 형식",
		"folder_text_add":"새 폴더 만들기",
		"folder_text_input_name":"이름을 입력하세요",
		"folder_text_cancel":"취소",
		"folder_text_summit":"확인",
		"folder_text_name_not_null":"이름을 입력할 수 없습니다. empty",
		"folder_text_add_success":"폴더가 성공적으로 생성되었습니다!",
		"folder_text_del_confirm":"삭제 확인됨",
		"folder_text_confirm":"선택한 폴더를 삭제하시겠습니까? 삭제 후 폴더의 메모는 휴지통으로 이동합니다.",
		"folder_text_del_success":"삭제되었습니다!",
		"folder_text_move":"이동됨",
		"folder_text_move_success":"이동되었습니다!",
		"folder_update_name":"폴더 이름이 변경되었습니다.",
		"folder_text_update_success":"수정되었습니다!",
		"empty_text":"사용 가능한 데이터가 없습니다.",
		"trans_text_null":"전사된 텍스트는 비워둘 수 없습니다.",
		"summary_text_null":"요약은 비워둘 수 없습니다.",
		"please_create_folder":"먼저 폴더를 생성하십시오."
	}
}